<template>
    <div class="card block md:flex justify-content-center">

        <MultiSelect v-model="estudantesSelecionados" :options="estudantes" filter optionLabel="nome" optionValue="id"
            placeholder="Selecione estudantes" :maxSelectedLabels="3" class="w-full " display="chip" />
        <Button :loading="btnLoadingAdd" :disabled="estudantesSelecionados.length < 1" icon="pi pi-plus"
            class="ml-0 mt-3 w-full md:ml-3 md:mt-0 md:w-10rem" label="Adicionar" @click="adicionarEstudantes" />
    </div>



    <DataTable v-if="estudantesNaTurma.length > 0" :value="estudantesNaTurma" dataKey="id" stripedRows class="mt-5">

        <Column field="img" header="Img">
            <template #body="slotProps">
                <Avatar :image="slotProps.data.users.img" class="mr-2" size="large" shape="circle"
                    @click="addImagetoUser(slotProps.data.users)" />
            </template>

        </Column>

        <Column field="nome" header="Nome">
            <template #body="slotProps">
                {{ slotProps.data.users.nome }}
            </template>
        </Column>

        <Column field="id" header="Remover">
            <template #body="slotProps">
                <Button label="Remover da turma" size="small" @click="excluirEstudanteDaTurma(slotProps.data.id)" />
            </template>
        </Column>



    </DataTable>



    <Toast />
</template>
<script setup>
import { ref, onMounted, defineProps } from 'vue'
import { useStore } from 'vuex'
import { supabase } from '@/supabase'
import MultiSelect from 'primevue/multiselect'
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import { useToast } from "primevue/usetoast"
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Avatar from 'primevue/avatar'
import cld from '@/cloudinary';


const estudantesSelecionados = ref([]);
const estudantes = ref([])
const estudantesNaTurma = ref([])
const store = useStore()
const btnLoadingAdd = ref(false)
const props = defineProps({
    turma: {
        type: Number,
        default: null
    },
    ano: {
        type: Number,
        default: null
    }
});
const ano = ref(props.ano);
const turma = ref(props.turma);

const selectedUserToAddImage = ref(null);
async function addImagetoUser(user){
    selectedUserToAddImage.value = user;
    const resultado = await openCloudinaryWidget();
    console.log(selectedUserToAddImage.value.nome);
    console.log(selectedUserToAddImage.value.id);
    console.log(resultado.secureUrl);
    await salvarIdImg(resultado.secureUrl, resultado.publicId);

}

onMounted(() => {
    listarEstudantes();
    listarEstudantesNaTurma();
    if (!widgetLoaded) {
        const script = document.createElement('script');
        script.src = 'https://widget.cloudinary.com/v2.0/global/all.js';
        script.onload = () => widgetLoaded = true;
        document.head.appendChild(script);
    }
    

})

const toast = useToast();
const showToastSuccess = (text) => {
    toast.add({ severity: 'success', detail: text, life: 3000 });
};
const showToastError = (text) => {
    toast.add({ severity: "error", detail: text, life: 3000 });
};




const listarEstudantes = async () => {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('users')
        .select('id,nome,img, estudantes_turmas (idDoEstudante)')
        .order('nome')
        .eq('funcao', 'estudante')
        .eq('ano', ano.value)
    if(data){
        estudantes.value = data.filter(estudante => estudante.estudantes_turmas.length === 0)
    }
    store.dispatch('updateLoading', false)
}

const adicionarEstudantes = async () => {

    btnLoadingAdd.value = true
    let estudantesTurmas = []
    estudantesSelecionados.value.forEach(item => estudantesTurmas.push({ 'idDoEstudante': item, 'idDaTurma': turma.value }))
    const { error } = await supabase
        .from('estudantes_turmas')
        .insert(estudantesTurmas)

    if (error) { showToastError(); return }
    showToastSuccess("Estudante adicionado com sucesso")
    estudantesSelecionados.value = []
    listarEstudantes()
    listarEstudantesNaTurma()
    btnLoadingAdd.value = false
}

const listarEstudantesNaTurma = async () => {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('estudantes_turmas')
        .select('id, idDaTurma, users (id, nome, email, img)')
        .order('users(nome)')
        .eq('idDaTurma', turma.value)

    if(data){ estudantesNaTurma.value = data }
    console.log(estudantesNaTurma.value)
    store.dispatch('updateLoading', false)
}

const excluirEstudanteDaTurma = async (id) => {
    store.dispatch('updateLoading', true)
    const { error } = await supabase
        .from('estudantes_turmas')
        .delete()
        .eq('id', id)
    if(error){
        showToastError("Ocorreu um erro ao excluir o estudante")
        store.dispatch('updateLoading',false)
    }
    store.dispatch('updateLoading', false)
    listarEstudantesNaTurma()
    listarEstudantes()
}
let widgetLoaded = false;

function openCloudinaryWidget() {
    if (!widgetLoaded) {
        alert('O widget de upload ainda está carregando. Por favor, tente novamente em alguns segundos.');
        return null;
    }

    return new Promise((resolve, reject) => {
        const widget = window.cloudinary.createUploadWidget(
            {
                cloudName: cld.cloudinaryConfig.cloud.cloudName,
                uploadPreset: 'img_estudantes',
                cropping: true,
                croppingAspectRatio: 1,
            },
            (error, result) => {
                if (error) {
                    reject(error);
                } else if (result && result.event === 'success') {
                    resolve({
                        secureUrl: result.info.secure_url,
                        publicId: result.info.public_id
                    });
                }
            }
        );

        widget.open();
    });
}



async function salvarIdImg(url, public_id) {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('users')
        .update({ img: url, img_public_id: public_id })
        .eq('id', selectedUserToAddImage.value.id)
        .select()

    if (error) {
        store.dispatch('updateLoading', false)
        alert(error.message)
        return
    }
    estudantesNaTurma.value.forEach(usuario => {
        if (usuario.users.id == selectedUserToAddImage.value.id) {
            usuario.users.img = url
        }
    })
    store.dispatch('updateLoading', false)
}


</script>